// Nitro's route-aware overload can exceed TypeScript's comparison depth in this large API.
// Keep response types explicit at call sites. Resolve $fetch only when the function is called so
// importing this utility never attempts to access the Nuxt instance during module evaluation.
export function morningFetch<T = unknown>(
  request: string,
  options?: Record<string, unknown>,
): Promise<T> {
  const fetcher = $fetch as unknown as (
    request: string,
    options?: Record<string, unknown>,
  ) => Promise<T>
  return fetcher(request, options)
}
